import type { RootState } from '@app/store';

export const selectLeadsLatestRegistryResult = ({
  leadsLatestRegistryResult,
}: RootState) => leadsLatestRegistryResult;

export const selectLeadsLatestRegistryLeads = (state: RootState) =>
  selectLeadsLatestRegistryResult(state).leads;

export const selectLeadsLatestRegistryTotalCount = (state: RootState) =>
  selectLeadsLatestRegistryResult(state).totalCount;

export const selectLeadsLatestRegistryRequestedMaxSize = (state: RootState) =>
  selectLeadsLatestRegistryResult(state).requestedMaxSize;

export const selectLeadsLatestRegistryHasNextPage = (state: RootState) => {
  const { hasAcceptedResult, leads, totalCount } =
    selectLeadsLatestRegistryResult(state);

  return (
    hasAcceptedResult &&
    leads.length > 0 &&
    totalCount !== null &&
    totalCount > leads.length
  );
};
